import { eTitleFees } from 'ui-toolkit/enums/eTitleFees';

export const titleFeeOptions = [
  { label: 'Title - Acris', value: eTitleFees.acris },
  { label: 'Title - Attorney', value: eTitleFees.attorney },
  { label: 'Title - Closer', value: eTitleFees.closer },
  { label: 'Title - Closing', value: eTitleFees.closing },
  { label: 'Title - Commitment', value: eTitleFees.commitment },
  { label: 'Title - Co-ordination', value: eTitleFees.coordination },
  { label: 'Title - CPL Borrower', value: eTitleFees.cpl_borrower },
  { label: 'Title - CPL Buyer', value: eTitleFees.cpl_buyer },
  { label: 'Title - CPL Lender', value: eTitleFees.cpl_lender },
  { label: 'Title - CPL Seller', value: eTitleFees.cpl_seller },
  { label: 'Title - Document Copies', value: eTitleFees.document_copies },
  { label: 'Title - Document Preparation', value: eTitleFees.document_preparation },
  { label: 'Title - Exam', value: eTitleFees.exam },
  { label: 'Title - Abstract and Exam', value: eTitleFees.abstract_and_exam },
  { label: 'Title - Attorney Document Review', value: eTitleFees.attorney_document_review },
  { label: 'Title - Escrow', value: eTitleFees.escrow },
  { label: 'Title - Extended Lenders Policy', value: eTitleFees.extended_lenders_policy },
  { label: 'Title - Hold Open', value: eTitleFees.hold_open },
  { label: "Title - Lender's Policy Guaranty Fee", value: eTitleFees.lenders_policy_guaranty },
  { label: "Title - Owner's Policy Guaranty Fee", value: eTitleFees.owners_policy_guaranty },
  { label: 'Title - HOI Endorsement', value: eTitleFees.hoi_endorsement },
  { label: 'Title - Homeowners Policy', value: eTitleFees.homeowners_policy },
  { label: 'Title - Lenders Policy', value: eTitleFees.lenders_policy },
  { label: 'Title - Municipal Lien Certification', value: eTitleFees.municipal_lien_certification },
  { label: 'Title - Recording Processing', value: eTitleFees.recording_processing },
  { label: 'Title - Search', value: eTitleFees.search },
  { label: 'Title - Search Report', value: eTitleFees.search_report },
  { label: 'Title - Settlement', value: eTitleFees.settlement },
  { label: 'Title - Standard Owners Policy', value: eTitleFees.standard_owners_policy },
  { label: 'Title - Sub Escrow', value: eTitleFees.sub_escrow },
  { label: 'Title - Survey', value: eTitleFees.survey },
  { label: 'Title - Tax Certification', value: eTitleFees.tax_certification },
  { label: 'Title - TIEFF Lenders Policy', value: eTitleFees.tieff_lenders_policy },
  { label: 'Title - TIEFF Owners Policy', value: eTitleFees.tieff_owners_policy },
  { label: 'Title - Title Closing', value: eTitleFees.title_closing },
  { label: 'Title - Title Opinion', value: eTitleFees.title_opinion },
  { label: 'Title - Updated Search', value: eTitleFees.updated_search },
  { label: 'Title - Updated Tax Certification', value: eTitleFees.updated_tax_certification },
  { label: 'Title - Owners State Policy', value: eTitleFees.owners_state_policy },
  { label: 'Title - Owners Guaranty', value: eTitleFees.owners_title_guaranty },
  { label: 'Title - Lenders Title Guaranty', value: eTitleFees.lenders_title_guaranty },
  { label: 'Title - Lenders State Policy', value: eTitleFees.lenders_state_policy },
];
